export const MenuItems = [
  {
    itemName: 'Home',
    cName: 'nav-link',
    path: '/#home',
    type: 'hash'
  },
  {
    itemName: 'Services',
    cName: 'nav-link',
    path: '/#services',
    type: 'hash'
  },
  {
    itemName: 'Our Exerptise',
    cName: 'nav-link',
    path: '/#expertises',
    type: 'hash'
  },
  {
    itemName: 'Who we are',
    cName: 'nav-link',
    path: '/#who-we-are',
    type: 'hash'
  },
 
  {
    itemName: 'Contact us',
    cName: 'nav-link',
    path: '/#contact-us',
    type: 'hash'
  },
  {
    itemName: 'Academy',
    cName: 'nav-link academy-btn',
    url: 'https://academy.simba-solution.com/',
    type: 'external'
  }
];
